@if (data(); as purchase) {
  <div class="psp-overlay" role="dialog" aria-modal="true" [attr.aria-label]="'PURCHASE.SUCCESS_TITLE' | translate">
    <div class="psp-modal" (click)="$event.stopPropagation()">
      <button type="button" class="psp-close" (click)="close()" [attr.aria-label]="'COMMON.CLOSE' | translate">×</button>

      <div class="psp-hero">
        <img class="psp-success-illustration" src="/PaymentSucess.png" [alt]="'PURCHASE.SUCCESS_TITLE' | translate" />
      </div>

      <h2 class="psp-title">{{ 'PURCHASE.SUCCESS_TITLE' | translate }}</h2>
      <p class="psp-sub">{{ 'PURCHASE.SUCCESS_SUB' | translate }}</p>

      <div class="psp-books">
        @for (item of purchase.items; track item.bookId) {
          <article class="psp-book">
            <div class="psp-book-cover">
              <span aria-hidden="true">{{ (item.title || '?').slice(0, 2).toUpperCase() }}</span>
              @if (imageSrc(item.imageUrl); as src) {
                <img [src]="src" [alt]="item.title" loading="lazy" />
              }
            </div>
            <div class="psp-book-info">
              <h3 class="psp-book-title">{{ item.title }}</h3>
              @if (item.author) {
                <p class="psp-book-author">{{ item.author }}</p>
              }
              @if (item.genre) {
                <span class="psp-book-genre">{{ item.genre }}</span>
              }
            </div>
            <strong class="psp-book-price">{{ formatPrice(item.lineTotal) }}</strong>
          </article>
        }
      </div>

      <div class="psp-perks">
        <div class="psp-perk">
          <span class="psp-perk-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/>
            </svg>
          </span>
          <span class="psp-perk-label">{{ 'PURCHASE.ADDED_LIBRARY' | translate }}</span>
        </div>
        <div class="psp-perk">
          <span class="psp-perk-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/>
            </svg>
          </span>
          <span class="psp-perk-label">{{ 'PURCHASE.AVAILABLE_DOWNLOAD' | translate }}</span>
        </div>
        <div class="psp-perk">
          <span class="psp-perk-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8">
              <path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z"/>
            </svg>
          </span>
          <span class="psp-perk-label">{{ 'PURCHASE.SAVED_BOOKS' | translate }}</span>
        </div>
      </div>

      <div class="psp-actions">
        <button type="button" class="psp-btn psp-btn--outline" (click)="goLibrary()">
          {{ 'PURCHASE.VIEW_LIBRARY' | translate }}
        </button>
        <button type="button" class="psp-btn psp-btn--fill" (click)="continueExploring()">
          {{ 'PURCHASE.CONTINUE_EXPLORING' | translate }}
        </button>
      </div>
    </div>
  </div>
}